import PropTypes from 'prop-types';
import { equals } from 'ramda';
import Presenter from 'utils/PropTypesPresenter';

const VERIFICATION_STATUSES = {
  verified: 'verified',
  unverified: 'unverified',
};

export default new Presenter(
  {
    applicationUrl: PropTypes.string,
    bundleCompanyName: PropTypes.string,
    company: PropTypes.string,
    companyEmailExtension: PropTypes.string,
    companyLogoUrl: PropTypes.string,
    driverLicense: PropTypes.string,
    email: PropTypes.string,
    profileImageUrl: PropTypes.string,
    loanOfficerId: PropTypes.number,
    loanOfficerName: PropTypes.string,
    location: PropTypes.string,
    mortgageCompanyNmls: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    nmls: PropTypes.numbers,
    offerings: PropTypes.arrayOf(PropTypes.string),
    phoneNumber: PropTypes.string,
    savedCompany: PropTypes.string,
    savedMortgageCompanyNmls: PropTypes.number,
    verificationStatus: PropTypes.string,
    savedNmls: PropTypes.number,
  },
  {
    isVerified(loanOfficer) {
      return equals(this.verificationStatus(loanOfficer), VERIFICATION_STATUSES.verified);
    },
  },
);



// WEBPACK FOOTER //
// ./src/presenters/administrator/LoanOfficerPresenter.js